module.exports = __webpack_public_path__ + "static/media/spotme.8c483a47.jpg";